import PrimaryButton from '../buttons/PrimaryButton';
import Icon from '@ant-design/icons';
import BasicCard from '../basicCard/BasicCard';
import './MainPromotion.scss';

type MainPromotionProps = {
  children: React.ReactNode;
  title: string;
  btnLabel: string;
  btnAction: () => void;
  btnIcon?: React.ReactNode;
  subtitle?: string;
};

const MainPromotion = ({
  children,
  title,
  btnLabel,
  btnAction,
  btnIcon,
  subtitle,
}: MainPromotionProps) => {
  return (
    <div className="main-promotion block rounded-3xl bg-card-bg-color md:flex md:h-[400px]">
      <div className="content flex w-full flex-col items-start justify-center gap-6 px-8 py-10 md:h-full md:w-1/2 md:px-14 xl:w-7/12">
        <h1 className="text-4xl font-medium text-black lg:text-5xl xl:text-6xl">{title}</h1>
        {subtitle && <p className="mb-2 text-base text-font-color">{subtitle}</p>}
        <PrimaryButton handleOnClick={btnAction}>
          <div className="px-3 py-1 text-xs font-medium md:text-sm">
            {btnIcon && <Icon className="mr-2">{btnIcon}</Icon>}
            {btnLabel}
          </div>
        </PrimaryButton>
      </div>
      <div className="display h-full w-full px-8 md:w-1/2 md:px-5 xl:w-5/12">
        <div className="md-w-[300px] mx-auto h-full md:mr-6 md:mt-16 lg:mx-1 lg:w-[400px]">
          <BasicCard radius="lg">
            <div className="display-content h-full w-full rounded-2xl bg-white">{children}</div>
          </BasicCard>
        </div>
        <div className="display-backdrop"></div>
      </div>
    </div>
  );
};

export default MainPromotion;
